import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const updateLocalStorage = (carro) => {
  localStorage.setItem("carro", JSON.stringify(carro));
};

const store = new Vuex.Store({
  state: {
    lineas: [],
    confirmacion: null,
    secciones: [],
  },
  actions: {},
  getters: {
    getTotal: (state) => {
      return (
        state.lineas
          .map((t) => t.Cantidad)
          .reduce((total, num) => total + num, 0) || 0
      );
    },
    getCantidad: (state) => (articulo) => {
      const item = state.lineas.find((i) => i.Id === articulo.Id);
      return item ? item.Cantidad : 0;
    },
    getImporteTotal: (state) => {
      return state.lineas
        .map((t) => t.Precio)
        .reduce((total, num) => total + num, 0);
    },
    getTituloSeccion: (state) => (idSeccion) => {
      const seccion = state.secciones.find((i) => i.Id == idSeccion);
      console.log("Seccion",seccion);
      console.log("Secciones", state.secciones, idSeccion);
      return seccion ? seccion.Nombre : "";
    }
    
  },
  mutations: {
    setLineas(state, lineas) {
      state.lineas = lineas;
    },

    addLinea(state, articulo, cantidad) {
      console.log("addLinea", articulo);
      let linea = state.lineas.find((p) => p.Id === articulo.Id);
      console.log("linea", linea);
      if (!linea) {
        state.lineas.push({
          Id: articulo.Id,
          Nombre: articulo.Nombre,
          Precio: articulo.Precio,
          PrecioUnitario: articulo.Precio,
          Cantidad: cantidad || 1,
          CantidadStock: articulo.CantidadStock,
          ControlStock: articulo.ControlStock,
          Imagen: articulo.Imagen
        });
      } else {
        linea.Cantidad += cantidad || 1;
        linea.Precio = linea.PrecioUnitario * linea.Cantidad;
      }
      updateLocalStorage(state.lineas);
    },
    removeLinea(state, articulo) {
      let item = state.lineas.find((l) => l.Id === articulo.Id);

      if (item) {
        if (item.Cantidad > 1) {
          item.Cantidad--;
          item.Precio = item.PrecioUnitario * item.Cantidad;
        } else {
          state.lineas = state.lineas.filter((l) => l.Id !== articulo.Id);
        }
        updateLocalStorage(state.lineas);
      }
    },
    loadFromLocalStorage(state) {
      const carro = localStorage.getItem("carro");
      if (carro) {
        state.lineas = JSON.parse(carro);
      }
    },
    clearCart(state) {
      localStorage.clear();
    },
    //Tienda
    saveSecciones(state, secciones) {
      state.secciones = secciones;
    },
  },
});

export default store;
